import React, { useState } from "react";
import { ScoreUploaderState } from "../../../state/admin/score-uploader/ScoreUploaderState";
import { ScoreUploaderStep } from "../../../types/admin/score-uploader/ScoreUploaderStep";
import StepIndicator from "../../common/StepIndicator";
import ScoreUploaderColumnMapping from "./steps/ScoreUploaderColumnMapping";
import ScoreUploaderConfirmation from "./steps/ScoreUploaderConfirmation";
import ScoreUploaderFileSelection from "./steps/ScoreUploaderFileSelection";
import ScoreUploaderProcessing from "./steps/ScoreUploaderProcessing";

const steps = [
  { step: ScoreUploaderStep.UploadFile, label: "Upload File" },
  { step: ScoreUploaderStep.MapColumns, label: "Map Columns" },
  { step: ScoreUploaderStep.Confirm, label: "Confirm" },
];

const initialState = new ScoreUploaderState({
  currentStep: ScoreUploaderStep.UploadFile,
  hasHeaderRow: true,
  scoreMappings: [],
  isLoading: false,
  validationResult: null,
  showValidationErrors: false,
  dataDate: new Date(), // Today by default
});

const ScoreUploaderWizard: React.FC = () => {
  const [state, setState] = useState<ScoreUploaderState>(initialState);

  const handleStateChange = (
    newState: ScoreUploaderState | Partial<ScoreUploaderState>
  ) => {
    // Handle both class instances and plain objects (for object spread compatibility)
    if (newState instanceof ScoreUploaderState) {
      setState(newState);
    } else {
      // Create new instance from current state + updates
      setState(new ScoreUploaderState({ ...state, ...newState }));
    }
  };

  const renderStep = () => {
    switch (state.currentStep) {
      case ScoreUploaderStep.UploadFile:
        return (
          <ScoreUploaderFileSelection
            state={state}
            onStateChange={handleStateChange}
          />
        );
      case ScoreUploaderStep.MapColumns:
        return (
          <ScoreUploaderColumnMapping
            state={state}
            onStateChange={handleStateChange}
          />
        );
      case ScoreUploaderStep.Confirm:
        return (
          <ScoreUploaderConfirmation
            state={state}
            onStateChange={handleStateChange}
          />
        );
      case ScoreUploaderStep.Processing:
        return (
          <ScoreUploaderProcessing
            state={state}
            onStateChange={handleStateChange}
          />
        );
      default:
        return null;
    }
  };

  // Only show stepper if we're not in the processing step
  const showStepper = state.currentStep !== ScoreUploaderStep.Processing;

  return (
    <div className="max-w-4xl mx-auto">
      {showStepper && (
        <div className="mb-8">
          <StepIndicator steps={steps} currentStep={state.currentStep} />
        </div>
      )}
      <div className="bg-white rounded-lg">{renderStep()}</div>
    </div>
  );
};

export default ScoreUploaderWizard;
